import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../../../../shared/services/base-api.service';
import { environment } from '../../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BaseWooCommerceV2ApiService extends BaseApiService {
  constructor(httpClient: HttpClient) {
    const baseApiUrl: string = environment.happyApi.baseUrl;
    const baseOptions = {
      // params: {
      // consumer_key: environment.wooCommerce.consumerKey,
      // consumer_secret: environment.wooCommerce.consumerSecret
      // }
    };

    super(httpClient, baseApiUrl, baseOptions);
  }
}
